<app-filter-header title="Filtrar notificacions denuncia"  (apply)="this.apply()" (reset)="this.reset()" i18n-title></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-date-edit id="notificacions-denuncia-filter-data" class="col-sm-6" i18n-label label="DataIni" [(value)]="filter.dataIni"></app-form-date-edit>
    <app-form-date-edit id="notificacions-denuncia-filter-data" class="col-sm-6" i18n-label label="DataFi" [(value)]="filter.dataFi"></app-form-date-edit>
  </div>
</div>